import './update.css';

import * as React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import Group from 'src/entities/Group';
import Member from 'src/entities/Member';
import Wiki from 'src/entities/Wiki';

import { updateWiki } from '../../actions/wiki';
import Navigation from '../Navigation/global';
import NavigationMember from '../Navigation/member';
import SwitchAdmin from '../Navigation/switchAdmin';

interface IProps {
  groupTitle: string;
  wikiId: string;
  account: Member;
  group: Group;
  wiki: Wiki;
  updateWiki: (wiki: Wiki) => void;
}

interface IState {
  wiki: Wiki;
  isUpdated: boolean;
}

class ShowComponent extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      wiki: this.props.wiki,
      isUpdated: false
    };

    this.onChangeTitle = this.onChangeTitle.bind(this);
    this.onChangeText = this.onChangeText.bind(this);
    this.updateWiki = this.updateWiki.bind(this);
  }

  render() {
    if (
      this.props.group === undefined ||
      this.props.wiki === undefined ||
      this.state.isUpdated
    ) {
      return (
        <Redirect
          to={{
            pathname: '/' + this.props.groupTitle + '/wiki/' + this.props.wikiId
          }}
        />
      );
    }

    if (!this.props.group.admins.includes(this.props.account.id)) {
      return (
        <Redirect
          to={{
            pathname: '/' + this.props.groupTitle + '/wiki/' + this.props.wikiId
          }}
        />
      );
    }

    return (
      <div id="WikiUpdate">
        <Navigation group={this.props.group.title} />

        <div id="NavigationFunction">
          <NavigationMember function="wiki" group={this.props.group} />

          {this.props.account.isSystemAdmin ||
          this.props.group.admins.includes(this.props.account.id) ? (
            <SwitchAdmin group={this.props.group} />
          ) : null}
        </div>

        <div id="Title">
          <input
            className="InputText"
            value={this.state.wiki.title}
            onChange={this.onChangeTitle}
          />
        </div>
        <textarea id="Text" onChange={this.onChangeText}>
          {this.state.wiki.text}
        </textarea>
        <div id="Actions">
          <button onMouseUp={this.updateWiki} onTouchEnd={this.updateWiki}>
            編集する
          </button>
          <Link
            to={'/' + this.props.group.title + '/wiki/' + this.props.wiki.id}
          >
            <span>記事に戻る</span>
          </Link>
        </div>
      </div>
    );
  }

  onChangeTitle(e: any) {
    const wiki = Object.assign({}, this.state.wiki);
    wiki.title = e.target.value;

    this.setState({
      wiki
    });
  }

  onChangeText(e: any) {
    const wiki = Object.assign({}, this.state.wiki);
    wiki.text = e.target.value;

    this.setState({
      wiki
    });
  }

  updateWiki() {
    this.props.updateWiki(this.state.wiki);
    this.setState({
      isUpdated: true
    });
  }
}

const mapStateToProps = (state: any, ownProps: any) => ({
  groupTitle: ownProps.match.params.group,
  wikiId: ownProps.match.params.wikiId,
  account: state.Account,
  group: state.Group.find(
    (group: Group) => group.title === ownProps.match.params.group
  ),
  wiki: state.Wiki.find(
    (wiki: Wiki) => wiki.id === Number(ownProps.match.params.wikiId)
  )
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    updateWiki(wiki: Wiki) {
      dispatch(updateWiki(wiki));
    }
  };
};

const Show = connect(
  mapStateToProps,
  mapDispatchToProps
)(ShowComponent);

export default Show;



// WEBPACK FOOTER //
// ./src/components/Wiki/update.tsx